// Signal Lens definitions — contextual entry points between content and the
// 3-question State ID. Lenses affect CONTEXT ONLY, never State ID scoring.

export const LENSES = {
  "pre-decision": {
    id: "pre-decision",
    name: "Pre-Decision State",
    headline: "The decision starts before the decision.",
    copy: "Your operating state may influence what you notice, how you anticipate and what information you bring into the next moment.",
    question: "What state are you bringing into your next consequential decision?",
    prompts: [
      ["Attention", "Are you noticing what you normally notice?"],
      ["Anticipation", "Are you thinking one step ahead, or mainly reacting to what's in front of you?"],
      ["Margin", "How much room do you have for something unexpected?"],
    ],
  },
  recovery: {
    id: "recovery",
    name: "Recovery State",
    headline: "Stopping work isn't always the same as changing state.",
    copy: "Your body can leave the performance environment while your attention remains inside it.",
    question: "Did you stop working — or did you actually change state?",
    prompts: [
      ["Disconnection", "Have the inputs actually stopped?"],
      ["Cognitive load", "Are you still processing work even though the workday has ended?"],
      ["Transition", "What could help you genuinely change operating state?"],
    ],
  },
  susceptibility: {
    id: "susceptibility",
    name: "State Susceptibility",
    headline: "Past resilience doesn't guarantee present capacity.",
    copy: "How you handled a similar demand before may not perfectly predict how you'll respond to it today.",
    question: "How much margin do you have for today's demand?",
    prompts: [
      ["Current capacity", "How does today's demand compare with what feels normal for you?"],
      ["Effort", "Is something familiar requiring more effort than usual?"],
      ["Margin", "How much additional demand could you comfortably absorb?"],
    ],
  },
  drift: {
    id: "drift",
    name: "Performance Drift",
    headline: "Performance can change before the outcome does.",
    copy: "The visible result may be one of the later signals. Signal State helps you notice what may be changing earlier.",
    question: "Has something changed even though your performance hasn't shown it yet?",
    prompts: [
      ["Change", "What feels different from your normal baseline?"],
      ["Effort", "Is maintaining normal performance taking more effort?"],
      ["Early signal", "What appears to be changing before the outcome does?"],
    ],
  },
};

export const getLens = (id) => LENSES[id] || null;
